const state = {
    namespaced: true,
    state: () => ({
        menuTree: [],
        popularQuery: [],
        searchResults: [],
        isSearching: false,
        isEmptySearch: false,
    }),
    getters: {
        getMenuTree: state => state.menuTree,
        getPopularQuery: state => state.popularQuery,
        getSearchResults: state => state.searchResults,
        getIsSearching: state => state.isSearching,
        getIsEmptySearch: state => state.isEmptySearch,
    },
    mutations: {
        SET_MENU_TREE(state, raw) {
            // рекурсивно проходим дерево и «приводим к единому виду»
            function normalize(items) {
                return items.map(item => {
                    return {
                        badge: item?.badge,
                        productCount: item?.product_count,
                        id: item?.id,
                        title: item?.categoryTitle || item?.subCategoryTitle,
                        url: item?.categoryUrl || item?.subCategoryUrl,
                        icon: item?.categoryIcon || item?.subcategoryIcon,
                        image: item?.image,
                        subcategories: item?.subcategories ? normalize(item?.subcategories) : [],
                    };
                });
            }
            state.menuTree = normalize(raw);
        },
        SET_POPULAR_QUERY(state, query) {
            state.popularQuery = query;
        },
        SET_SEARCH_RESULTS(state, results) {
            state.searchResults = results;
        },
        SET_IS_SEARCHING(state, value) {
            state.isSearching = value;
        },
        SET_IS_EMPTY_SEARCH(state, value) {
            state.isEmptySearch = value;
        },
    },
    actions: {
        async fetchMenuTree({ commit }) {
            try {
                const menuTree = await this.$axios.$get('/general/menu_tree');
                commit('SET_MENU_TREE', menuTree);
            } catch (err) {
                console.error('Не удалось загрузить меню', err);
            }
        },
        async fetchPopularQuery({ commit }) {
            try {
                const popularQuery = await this.$axios.$get('/general/popular_query');
                commit('SET_POPULAR_QUERY', popularQuery);
            } catch (e) {
                console.error(e);
            }
        },
        async fetchResults({ commit }, { query, category }) {
            commit('SET_IS_SEARCHING', true);
            commit('SET_IS_EMPTY_SEARCH', false);
            try {
                let url = null;
                const params = { query };
                if (!query || query?.length < 2) {
                    return commit('SET_SEARCH_RESULTS', []);
                }
                if (!category || category === 'all') {
                    url = 'general/v2/search/search/';
                } else {
                    url = `general/v2/category/${category}/`;
                }
                const data = await this.$axios.$get(url, { params });
                const products = data?.data?.products || data?.products || [];

                if (products?.length) {
                    commit('SET_SEARCH_RESULTS', products);
                } else {
                    commit('SET_SEARCH_RESULTS', []);
                    commit('SET_IS_EMPTY_SEARCH', true);
                }
            } catch (err) {
                // commit('setError', err)
            } finally {
                commit('SET_IS_SEARCHING', false);
                // commit('setLoading', false)
            }
        },
    },
};

export default state;
